'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialState = exports.selectPagePromotion = exports.setPagePromotion = exports.finishLoadingBar = exports.startLoadingBar = exports.useSellHeader = exports.useReducedFooter = exports.useReducedNavigation = exports.useDarkSellHeader = exports.clearLogoLink = exports.setLogoLink = exports.toggleFlag = exports.setFlag = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_FLAG = 'classpass/page/SET_FLAG';
var TOGGLE_FLAG = 'classpass/page/TOGGLE_FLAG';
var USE_DARK_SELL_HEADER = 'classpass/page/USE_DARK_SELL_HEADER';
var USE_REDUCED_NAV = 'classpass/page/USE_REDUCED_NAV';
var USE_REDUCED_FOOTER = 'classpass/page/USE_REDUCED_FOOTER';
var USE_SELL_HEADER = 'classpass/page/USE_SELL_HEADER';
var SET_LOGO_LINK = 'classpass/page/SET_LOGO_LINK';
var START_LOADING_BAR = 'classpass/page/START_LOADING_BAR';
var FINISH_LOADING_BAR = 'classpass/page/FINISH_LOADING_BAR';
var SET_PAGE_PROMOTION = 'classpass/page/SET_PAGE_PROMOTION';

var setFlag = exports.setFlag = function setFlag(key, value) {
  return { type: SET_FLAG, data: { key: key, value: value } };
};
var toggleFlag = exports.toggleFlag = function toggleFlag(key) {
  return { type: TOGGLE_FLAG, data: key };
};

var setLogoLink = exports.setLogoLink = function setLogoLink(path) {
  return { type: SET_LOGO_LINK, data: path };
};
var clearLogoLink = exports.clearLogoLink = setLogoLink.bind(null, null);

var useDarkSellHeader = exports.useDarkSellHeader = function useDarkSellHeader() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return { type: USE_DARK_SELL_HEADER, data: use };
};
var useReducedNavigation = exports.useReducedNavigation = function useReducedNavigation() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return { type: USE_REDUCED_NAV, data: use };
};
var useReducedFooter = exports.useReducedFooter = function useReducedFooter() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return { type: USE_REDUCED_FOOTER, data: use };
};
var useSellHeader = exports.useSellHeader = function useSellHeader() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return { type: USE_SELL_HEADER, data: use };
};
var startLoadingBar = exports.startLoadingBar = function startLoadingBar() {
  return { type: START_LOADING_BAR };
};
var finishLoadingBar = exports.finishLoadingBar = function finishLoadingBar() {
  return { type: FINISH_LOADING_BAR };
};
var setPagePromotion = exports.setPagePromotion = function setPagePromotion(promotion) {
  return { type: SET_PAGE_PROMOTION, data: promotion };
};

var selectPagePromotion = exports.selectPagePromotion = function selectPagePromotion(state) {
  return state.page.pagePromotion;
};

var getInitialState = exports.getInitialState = function getInitialState() {
  return {
    reducedNav: false,
    reducedFooter: false,
    sellHeader: false,
    flags: {
      showCookiePolicy: true
    },
    logoLink: null,
    loadingBarPercent: 0,
    pagePromotion: null
  };
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_FLAG:
      return (0, _extends5.default)({}, state, {
        flags: (0, _extends5.default)({}, state.flags, (0, _defineProperty3.default)({}, action.data.key, action.data.value))
      });
    case TOGGLE_FLAG:
      return (0, _extends5.default)({}, state, {
        flags: (0, _extends5.default)({}, state.flags, (0, _defineProperty3.default)({}, action.data, !state.flags[action.data]))
      });
    case USE_DARK_SELL_HEADER:
      return (0, _extends5.default)({}, state, {
        sellHeader: action.data,
        darkNav: action.data
      });
    case USE_REDUCED_NAV:
      return (0, _extends5.default)({}, state, {
        reducedNav: action.data
      });
    case USE_REDUCED_FOOTER:
      return (0, _extends5.default)({}, state, {
        reducedFooter: action.data
      });
    case USE_SELL_HEADER:
      return (0, _extends5.default)({}, state, {
        sellHeader: action.data
      });
    case SET_LOGO_LINK:
      return (0, _extends5.default)({}, state, {
        logoLink: action.data
      });
    case START_LOADING_BAR:
      return (0, _extends5.default)({}, state, {
        loadingBarPercent: 10
      });
    case FINISH_LOADING_BAR:
      return (0, _extends5.default)({}, state, {
        loadingBarPercent: 100
      });
    case SET_PAGE_PROMOTION:
      return (0, _extends5.default)({}, state, {
        pagePromotion: action.data
      });
    default:
      return state;
  }
}